import { render, staticRenderFns } from "./Searchitem.vue?vue&type=template&id=2c23d0b0&"
import script from "./Searchitem.vue?vue&type=script&lang=js&"
export * from "./Searchitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports